import React from "react";
import { Award, Brain, TrendingUp, Globe, Zap, Cpu, Handshake } from "lucide-react";
import { Reveal, StaggerGroup, StaggerItem } from "./Reveal";

const REASONS = [
  { icon: Award, title: "11+ Years Experience", desc: "A decade of shipping brands that perform in the real world." },
  { icon: Brain, title: "Brand-first Thinking", desc: "Strategy before pixels — every choice earns its place." },
  { icon: TrendingUp, title: "Business-focused Design", desc: "Design measured by outcomes, not just aesthetics." },
  { icon: Globe, title: "Global Client Experience", desc: "Trusted by teams across the USA, UK, UAE and Australia." },
  { icon: Zap, title: "Fast Communication", desc: "Clear, responsive and reliable from first email onward." },
  { icon: Cpu, title: "AI-powered Workflow", desc: "Modern tooling to explore more and deliver faster." },
  { icon: Handshake, title: "Long-term Partnership", desc: "A creative partner invested in your growth, not a one-off." },
];

export const WhyWorkWithMe = () => {
  return (
    <section className="py-24 md:py-32 lg:py-40 bg-cream" data-testid="why-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-32">
            <Reveal>
              <div className="flex items-center gap-3 mb-6">
                <span className="h-px w-10 bg-gold" />
                <span className="text-xs tracking-[0.25em] uppercase font-semibold text-gold">Why Me</span>
              </div>
              <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05] text-charcoal">
                A partner who thinks in <span className="italic text-burgundy">outcomes.</span>
              </h2>
              <p className="mt-6 text-base text-charcoal/70 leading-relaxed">
                You're not hiring a pair of hands — you're gaining a strategic creative partner
                focused on helping your brand grow.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="lg:col-span-8">
          <StaggerGroup className="grid grid-cols-1 sm:grid-cols-2 gap-6" stagger={0.06}>
            {REASONS.map((r) => {
              const Icon = r.icon;
              return (
                <StaggerItem key={r.title}>
                  <div className="group h-full bg-white/60 backdrop-blur-sm border border-charcoal/5 rounded-2xl p-7 hover:border-gold/60 transition-colors duration-500 cursor-hover">
                    <Icon size={22} strokeWidth={1.6} className="text-burgundy" />
                    <h3 className="mt-5 font-heading text-xl text-charcoal">{r.title}</h3>
                    <p className="mt-2 text-sm text-charcoal/60 leading-relaxed">{r.desc}</p>
                  </div>
                </StaggerItem>
              );
            })}
          </StaggerGroup>
        </div>
      </div>
    </section>
  );
};
